import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { Button } from './ui/button';
import { siteData } from '../mockData';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const testimonials = siteData.testimonials;

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 bg-[#f7f6f3] relative">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-xs tracking-[0.3em] text-gray-500 uppercase mb-4">Client Stories</p>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-3">
            Testimonials
          </h2>
          <div className="w-16 h-[1px] bg-gray-900/30 mx-auto"></div>
        </div>

        <div className="relative">
          <div className="bg-white rounded-2xl p-10 md:p-14 shadow-[0_8px_40px_rgba(0,0,0,0.06)] border border-gray-100 min-h-[350px] flex flex-col justify-between">
            <div>
              <Quote className="text-gray-200 mb-6" size={48} strokeWidth={1} />
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-8 font-light">
                {testimonials[currentIndex].text}
              </p>
            </div>
            <div className="flex items-center justify-between">
              <p className="text-sm font-medium text-gray-900 tracking-wide">
                {testimonials[currentIndex].author}
              </p>
              <div className="flex items-center gap-3">
                <button
                  onClick={prevTestimonial}
                  className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center text-gray-600 hover:bg-gray-900 hover:text-white hover:border-gray-900 transition-all duration-300"
                  aria-label="Previous testimonial"
                >
                  <ChevronLeft size={18} />
                </button>
                <button
                  onClick={nextTestimonial}
                  className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center text-gray-600 hover:bg-gray-900 hover:text-white hover:border-gray-900 transition-all duration-300"
                  aria-label="Next testimonial"
                >
                  <ChevronRight size={18} />
                </button>
              </div>
            </div>
          </div>

          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-1 rounded-full transition-all duration-500 ${
                  index === currentIndex ? 'bg-gray-900 w-8' : 'bg-gray-300 w-4'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <Link to="/testimonials">
            <Button 
              variant="outline" 
              size="lg"
              className="border border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white transition-all duration-500 rounded-full px-10"
            >
              MORE TESTIMONIALS
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
